import { Component, input } from '@angular/core';
import { NewlineToBrPipe } from '../../../../shared/pipes/new-line-to-br.pipe';
import { SafeHtmlPipe } from '../../../../shared/pipes/safe-html.pipe';

@Component({
  selector: 'app-gdpr-statement',
  imports: [NewlineToBrPipe, SafeHtmlPipe],
  templateUrl: './gdpr-statement.component.html',
  styleUrl: './gdpr-statement.component.scss',
})
export class GdprStatementComponent {
  heading = input<string>();
  value = input<string>();
  afterText = input<string>();
  headingLevel = input<1 | 2 | 3 | 4 | 5 | 6>(3);
  private static nextId = 1;
  headingId = `gdpr-statement-heading-${GdprStatementComponent.nextId++}`;
}
